// extracted by mini-css-extract-plugin
module.exports = {"container":"_gM","content":"_gN","left_side":"_gO","left_logo":"_gP","left_text":"_gQ","right_side":"_gR"};